<template>
  <div
    class="cxm-ProgressLabelBarItem-Container"
    :style="dynamicWidthStyle"
  >
    <div
      class="cxm-ProgressLabelBarItem-Content"
    >
      <div
        :class="classes"
        :style="activeBarStyle"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProgressLabelBarItem',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    dynamicWidthStyle() {
      return { width: this.item.size };
    },
    activeBarStyle() {
      return {
        backgroundColor: `var(${this.item.color})`,
      };
    },
    classes() {
      const baseClass = 'cxm-ProgressLabelBarItem';

      if (this.item.firstRoundStyle && this.item.lastRoundStyle) {
        return `${baseClass} -fullRounded`;
      }
      if (this.item.firstRoundStyle) {
        return `${baseClass} -firstRounded`;
      }
      if (this.item.lastRoundStyle) {
        return `${baseClass} -lastRounded`;
      }
      return baseClass;
    },
  },
};
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.cxm-ProgressLabelBarItem-Container {
  height: var(--track-spacing-sm);
  width: 100%;
}

.cxm-ProgressLabelBarItem-Content {
  position: relative;
  width: 100%;
  height: inherit;
}

.cxm-ProgressLabelBarItem {
  position: absolute;
  top: 0;
  left: 0;
  height: inherit;
  width: 100%;

  &.-fullRounded {
    border-radius: var(--track-border-radius-sm);
  }

  &.-firstRounded {
    border-radius: var(--track-border-radius-sm) 0 0 var( --track-border-radius-sm);
  }

  &.-lastRounded {
    border-radius: 0 var(--track-border-radius-sm) var(--track-border-radius-sm) 0;
  }
}
</style>
